import React, { Component } from "react";
import NavEN from "../Symbols/NavEN";
import FooterEN from "../Symbols/FooterEN";
import PO1 from "../../assets/po_1.png";
import PO2 from "../../assets/po_2.jpg";
import PO3 from "../../assets/po_3.jpg";
import PO5 from "../../assets/w2w_1.jpg";
import "../../stylesheets/Kontakt.css";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import CRIMPEN from "../../assets/PAN_PRO_Kompetenzfolder_CRIMP-CON_EN.pdf";
import BOARDEN from "../../assets/PAN_PRO_Kompetenzfolder_BOARD-CON_EN.pdf";
import LATEN from "../../assets/PAN_PRO_Kompetenzfolder_LC127_Beschnitt_EN_20251020.pdf";

class ProduktuebersichtEN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docs: [],
    }
    this.btn1 = React.createRef();
    this.btn2 = React.createRef();
    this.btn3 = React.createRef();
    this.state = {
      active: "",
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let count = 1;
    let records = [];
    for (let i = 0; i < count; i++) {
      const response = await fetch(
        `https://api.airtable.com/v0/appiUuQajhQ6Drt6x/Docs?view=Sorted`, { headers: { 'Authorization': 'Bearer patSxqK40aDpd0iY6.beedbae8aef0d8ef37eaa0268af4654eb5113643efb69777ef67367c2031ee09' } }
      );
      const data = await response.json();
      records = records.concat(data.records);
    }
    this.setState({
      docs: records,
    });
  };

  changeView = (e, target) => {
    if (target === "1") {
      this.btn1.current.classList.add("active")
      this.btn2.current.classList.remove("active")
      this.btn3.current.classList.remove("active")
    } else if (target === "2") {
      this.btn1.current.classList.remove("active")
      this.btn2.current.classList.add("active")
      this.btn3.current.classList.remove("active")
    } else if (target === "3") {
      this.btn1.current.classList.remove("active")
      this.btn2.current.classList.remove("active")
      this.btn3.current.classList.add("active")
    }
    this.setState({
      active: target,
    });
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - Product Overview</title>
          <meta
            name="description"
            content="Pancon, based in Germany, is producing and distributing electromechanical components since 1968."
          />
          <meta property="og:title" content="Pancon - Kontakt" />
          <meta
            property="og:description"
            content="Pancon, based in Germany, is producing and distributing electromechanical components since 1968."
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/produktuebersicht"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/product-overview"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavEN />
        <div
          className="section flex first center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h1>Product Overview</h1>
            </div>
            <div className="flex center-h center-v po-box">
              <div ref={this.btn1} onClick={(event) => this.changeView(event, "1")} className="third flex center-h center-v">
                <img src={PO5}></img>
                <h3>Wire 2 Wire</h3>
              </div>
              <div ref={this.btn2} onClick={(event) => this.changeView(event, "2")} className="third flex center-h center-v">
                <img src={PO2}></img>
                <h3>Wire 2 Board</h3>
              </div>
              <div ref={this.btn3} onClick={(event) => this.changeView(event, "3")} className="third flex center-h center-v">
                <img src={PO3}></img>
                <h3>Board 2 Board</h3>
              </div>
            </div>
            <div className="po-box-2">
              {this.state.active == "1" || this.state.active == "2" || this.state.active == "3" ? <h2>Product Groups</h2> : null}
              {this.state.active == "1" ? (
                <div className="flex">
                  <Link target={"_blank"} className="half" to="/en/products?series=MAS-CON">
                    <h3>MAS-CON</h3>
                    <p className="body">In the MAS-CON range, Pancon offers male and female connectors together with accessories in two different sizes. Series 100 and Series 156 . The designations are the spacing of the contacts in a row. Series 100 has a spacing of 0.100 inch (2.54 mm) and Series 156 has a spacing of 0.156 inch {"(3.98 mm)"}. Both are common pitch dimensions in the electrical industry.</p>
                  </Link>
                  <Link target={"_blank"} className="half" to="/en/products?series=CRIMP-CON">
                    <h3>CRIMP-CON</h3>
                    <p className="body">The Crimp-Con product line consists of different pitches for creating Wire 2 Wire and Wire 2 Board connections.<br></br><br></br>1,00mm / 1,25mm / 1,27mm / 1,50mm / 2,00mm / 2,50mm / 2,54mm / 3,00mm / 3,96mm / 4,20mm / 5,08mm</p>
                    <a
                      target="_blank"
                      href={CRIMPEN}
                    >
                      <div className="flex marg-top">
                        <button className="default">Flyer</button>
                      </div>
                    </a>
                  </Link>
                  <Link target={"_blank"} className="half" to="/en/products?series=LAT-CON">
                    <h3>LAT-CON</h3>
                    <p className="body">The LAT-CON connector family is designed for use on printed circuit boards in conjunction with ribbon cables. Pancon offers both female and male connectors in different sizes: The 033 series with 1.27mm and the 050 and 057 series with 2.54mm distance from contact to contact.</p>
                    <a
                      target="_blank"
                      href={LATEN}
                    >
                      <div className="flex marg-top">
                        <button className="default">Flyer</button>
                      </div>
                    </a>
                  </Link>
                </div>) : null}
              {this.state.active == "2" ? (
                <div className="flex">
                  <Link target={"_blank"} className="half" to="/en/products?series=MAS-CON">
                    <h3>MAS-CON</h3>
                    <p className="body">In the MAS-CON range, Pancon offers male and female connectors together with accessories in two different sizes. Series 100 and Series 156 . The designations are the spacing of the contacts in a row. Series 100 has a spacing of 0.100 inch (2.54 mm) and Series 156 has a spacing of 0.156 inch {"(3.98 mm)"}. Both are common pitch dimensions in the electrical industry.</p>
                  </Link>
                  <Link target={"_blank"} className="half" to="/en/products?series=CRIMP-CON">
                    <h3>CRIMP-CON</h3>
                    <p className="body">The Crimp-Con product line consists of different pitches for creating Wire 2 Wire and Wire 2 Board connections.<br></br><br></br>1,00mm / 1,25mm / 1,27mm / 1,50mm / 2,00mm / 2,50mm / 2,54mm / 3,00mm / 3,96mm / 4,20mm / 5,08mm</p>
                    <a
                      target="_blank"
                      href={CRIMPEN}
                    >
                      <div className="flex marg-top">
                        <button className="default">Flyer</button>
                      </div>
                    </a>
                  </Link>
                  <Link target={"_blank"} className="half" to="/en/products?series=LAT-CON">
                    <h3>LAT-CON</h3>
                    <p className="body">The LAT-CON connector family is designed for use on printed circuit boards in conjunction with ribbon cables. Pancon offers both female and male connectors in different sizes: The 033 series with 1.27mm and the 050 and 057 series with 2.54mm distance from contact to contact.</p>
                    <a
                      target="_blank"
                      href={LATEN}
                    >
                      <div className="flex marg-top">
                        <button className="default">Flyer</button>
                      </div>
                    </a>
                  </Link>
                  <Link target={"_blank"} className="half" to="/en/products?series=HI-CON">
                    <h3>HI-CON</h3>
                    <p className="body">The HI-CON product line are connectors according to the following standards:</p>
                    <ul><li>DIN EN 60 603-2</li><li>DIN 41612</li><li>IEC 60 603-2</li></ul>
                    <p className="body">These connectors are mainly used on printed circuit boards.</p>
                  </Link>
                </div>) : null}
              {this.state.active == "3" ? (
                <div className="flex">
                  <Link target={"_blank"} className="half" to="/en/products?series=HI-CON">
                    <h3>HI-CON</h3>
                    <p className="body">The HI-CON product line are connectors according to the following standards:</p>
                    <ul><li>DIN EN 60 603-2</li><li>DIN 41612</li><li>IEC 60 603-2</li></ul>
                    <p className="body">These connectors are mainly used on printed circuit boards.</p>
                  </Link>
                  <Link target={"_blank"} className="half" to="/en/products?series=Board-Con">
                    <h3>BOARD-CON</h3>
                    <p className="body">The Board-Con product line includes board 2 board plug-in systems (male and female connectors) in various designs and pitch dimensions:<br></br>0,8mm / 1,00mm / 1,27mm / 2,00mm /2,50mm / 2,54mm / 3,96mm / 4,20mm / 5,08mm</p>
                    <a
                      target="_blank"
                      href={BOARDEN}
                    >
                      <div className="flex marg-top">
                        <button className="default">Flyer</button>
                      </div>
                    </a>
                  </Link>
                </div>) : null}
              <div className="po-box-2">
                <h2>Additional Documents</h2>

                <div className="flex center-h sonstiges">
                  <a
                    target="_blank"
                    href={this.state.docs ? this.state.docs[6].fields.Document_EN[0].url : ""}
                  >
                    <div className="flex marg-top">
                      <button className="default">Pancon Brochure</button>
                    </div>
                  </a>
                  <a
                    target="_blank"
                    href={this.state.docs ? this.state.docs[7].fields.Document_EN[0].url : ""}
                  >
                    <div className="flex marg-top">
                      <button className="default">Terminal Blocks</button>
                    </div>
                  </a>
                  <a
                    target="_blank"
                    href={this.state.docs ? this.state.docs[8].fields.Document_EN[0].url : ""}
                  >
                    <div className="flex marg-top">
                      <button className="default">Optimal Shelf Life</button>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section flex center-h">
          <div className="medium flex">
            <div className="half flex center-v center-h">
              <p className="eye-catcher">Not sure?</p>
            </div>
            <div className="half flex center-v center-h col">
              <Link className="default" to="/en/products">
                <span>Show all products</span>
              </Link>
              <Link className="default" to="/en/accessories-and-tools">
                <span>Accessories and Tools</span>
              </Link>
            </div>
          </div>
        </div>
        <FooterEN />
      </div>
    );
  }
}

export default ProduktuebersichtEN;
